var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 25,
    viewBox: "0 0 21 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4998 23.5458L16.8292 18.9996C17.4606 18.5462 17.9574 18.0007 18.3111 17.3769C18.6634 16.7562 18.8764 16.0509 18.9425 15.2742L19.7893 5.27272C18.2084 5.14644 13.9429 4.5173 10.5006 1.37999C7.05743 4.5173 2.7927 5.14644 1.21187 5.27272L2.05858 15.2742C2.12401 16.0502 2.33701 16.7562 2.69 17.3769C3.04375 18.0007 3.54051 18.5462 4.17193 18.9996L10.5013 23.5458H10.4998ZM17.507 19.9414L10.849 24.7234C10.6512 24.8725 10.372 24.8832 10.1605 24.731L3.49258 19.9414C2.72271 19.3883 2.11488 18.7196 1.67821 17.9505C1.24002 17.1791 0.976803 16.3134 0.896924 15.3701L6.65872e-06 4.77291H0.00228894C0.000767456 4.75846 6.65872e-06 4.74324 6.65872e-06 4.72803C-0.00151483 4.40775 0.257899 4.14682 0.577412 4.14606C0.593388 4.14606 6.07759 4.14606 10.0898 0.168885C10.3157 -0.0562951 10.6816 -0.0562951 10.9083 0.168885C14.7174 3.94522 19.8539 4.13541 20.3766 4.1453C20.4062 4.14302 20.4359 4.14378 20.4656 4.14606C20.7858 4.17268 21.0239 4.4534 20.9981 4.77367L20.1012 15.3708C20.0213 16.3142 19.7573 17.1799 19.3199 17.9513C18.8832 18.7204 18.2761 19.3891 17.5063 19.9422L17.507 19.9414Z",
    fill: "#D4AD53"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.38751 12.089L9.23823 14.9515L14.9515 9.2264",
    stroke: "#F5F5F5",
    strokeWidth: 1.675,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.264a9ef62ebd5586183fb6c9642c978e.svg";
export { ForwardRef as ReactComponent };